import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarTypes, CustomeSnackBarComponent } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  _snackbar = inject(MatSnackBar);

  public openSnackbar(type: SnackBarTypes, message: string) {
    const panelClass = type == SnackBarTypes.success ? 'snak-success' : 'snack-err';
    this._snackbar.openFromComponent(CustomeSnackBarComponent, {
      duration:  3000,
      data: {
        type: type,
        message: message,
      },
      panelClass
    });

  }
}
